// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);
// =====================================================
// Newsroom single article
// =====================================================
// Fixing the arrow links html inside of article
(() => {
  const links = document.querySelectorAll('article a.hover-arrow');
  if (links.length > 0) {
    links[0].classList.add('first-only'); // for margin top
    links.forEach(function(elem) {
      elem.innerHTML = `<span>${elem.innerHTML}</span>
        <div class="arrow">
          <svg version="1.1" id="arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve">
            <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z" />
          </svg>
        </div>
        <div class="bg"></div>`;
    });
  }
})();
// =====================================================
// Pinning Back button
// =====================================================
// (() => {
//   gsap.to('.backbutton', {
//     scrollTrigger: {
//       trigger: '.backbutton',
//       start: 'top 200px',
//       endTrigger: 'article.newsroom',
//       end: 'bottom top',
//       pin: true,
//       markers: true,
//     },
//   });
// })();
